import { InformationDialogService } from '@shared/components/dialogs/information-dialog/information-dialog.service';
import { TolgeeService } from '@core/translation/tolgee.service';
import { environment } from '@env/environment';
import { BcmTenantPermission } from '@modules/bcm/bcm-tenant-permission';
import { getUserLanguagePreference } from '@modules/bcm/@shared/utils/user-language-preference.util';

export const BCM_DEFAULT_LANGUAGE = 'de';

export interface MultilingualismPermissionCheck {
    hasMultilingualismLicense(): boolean;
}

export function anyAccessibleTenantHasMultilingualism(
    tenants: ReadonlyArray<{ permissions?: BcmTenantPermission[] }>,
): boolean {
    return tenants.some(tenant =>
        (tenant.permissions || []).includes(BcmTenantPermission.MULTILINGUALISM),
    );
}

export function tenantHasMultilingualism(tenantService: MultilingualismPermissionCheck): boolean {
    return tenantService.hasMultilingualismLicense();
}

export function canApplyLanguage(langCode: string, tenantService: MultilingualismPermissionCheck): boolean {
    if (!langCode || langCode === BCM_DEFAULT_LANGUAGE) {
        return true;
    }

    return tenantHasMultilingualism(tenantService);
}

export function openMultilingualismSalesDialog(informationDialogService: InformationDialogService): void {
    const bcm = environment.bcm;

    informationDialogService
        .useWarnTheme()
        .setTitle(TolgeeService.translate('layout.multilingualism.license.upgradeTitle'))
        .setBody(TolgeeService.translate('layout.multilingualism.license.upgradeBody', {
            supportMail: bcm.supportMail,
            supportPhone: bcm.supportPhone,
            supportPhoneBeautified: bcm.supportPhoneBeautified,
        }))
        .setTheme('warn')
        .setButton({ text: TolgeeService.translate('common.close'), color: 'warn' })
        .setDialogConfig({ panelClass: 'wider-dialog' })
        .open();
}

export function resolveAllowedLanguage(
    langCode: string | null | undefined,
    tenantService: MultilingualismPermissionCheck,
): string {
    const language = langCode || BCM_DEFAULT_LANGUAGE;

    return canApplyLanguage(language, tenantService) ? language : BCM_DEFAULT_LANGUAGE;
}

/**
 * Nutzer-weite Präferenz (localStorage) vor Mandanten-DB; Modul-Gate bleibt aktiv.
 */
export function resolveEffectiveUserLanguage(
    tenantDbLanguage: string | null | undefined,
    tenantService: MultilingualismPermissionCheck,
): string {
    const preferred = getUserLanguagePreference() || tenantDbLanguage;

    return resolveAllowedLanguage(preferred, tenantService);
}
